module.exports = __webpack_public_path__ + "static/quote_1-df1fbdf8cc34e9341b5a7529d7376824.png";